/**
 * Experience API 패키지 URL
 * @type {string}
 */
const packages = {
  auth: `/auth`,
  utilities: `/utilities`,
  services: `/services`,
  holdings: `/holdings`,
};

/**
 * Experience API 업무 구분 URL
 * @type {string}
 */
const sectors = {
  auth: {
    verification: `${packages.auth}/verification`,
    certification: `${packages.auth}/certification`,
    identity: `${packages.auth}/identity`,
    authenticator: `${packages.auth}/authenticator`,
    user: `${packages.auth}/user`,
  },
  utilities: {
    functions: `${packages.utilities}/functions`,
    settings: `${packages.utilities}/settings`,
    app: `${packages.utilities}/app`,
    mydata: `${packages.utilities}/mydata`,
  },
  services: {
    member: `${packages.services}/member`,
    kyc: `${packages.services}/kyc`,
    deposits: `${packages.services}/deposits`,
  },
  holdings: {
    assets: `${packages.holdings}/assets`,
  },
};

/**
 * Experience API 업무 세구분 URL
 * @type {string}
 */
const details = {
  auth: {
    verification: {
      additional: `${sectors.auth.verification}/additional`,
      tokens: `${sectors.auth.verification}/tokens`,
      fintech: `${sectors.auth.verification}/fintech`,
      fido: `${sectors.auth.verification}/fido`,
      sign: `${sectors.auth.verification}/sign`,
    },
    settings: {},
    certification: {
      fintech: `${sectors.auth.certification}/fintech`,
    },
    identity: {
      liveness: `${sectors.auth.identity}/liveness`,
      ocr: `${sectors.auth.identity}/ocr`,
    },
    authenticator: {
      management: `${sectors.auth.authenticator}/management`,
    },
    user: {
      help: `${sectors.auth.user}/help`,
      settings: `${sectors.auth.user}/settings`,
    },
  },
  utilities: {
    functions: {
      terms: `${sectors.utilities.functions}/terms`,
      edoc: `${sectors.utilities.functions}/edoc`,
      account: `${sectors.utilities.functions}/account`,
      search: `${sectors.utilities.functions}/search`,
      clickToCall: `${sectors.utilities.functions}/clickToCall`,
      holiday: `${sectors.utilities.functions}/holiday`,
      tradeinfo: `${sectors.utilities.functions}/tradeinfo`,
      comfyBank: `${sectors.utilities.functions}/comfyBank`,
      emergency: `${sectors.utilities.functions}/emergency`,
      authority: `${sectors.utilities.functions}/authority`,
    },
    settings: {
      code: `${sectors.utilities.settings}/code`,
    },
    app: {
      review: `${sectors.utilities.app}/review`,
    },
    mydata: {
      public: `${sectors.utilities.mydata}/public`,
    },
  },
  services: {
    member: {
      findDetail: `${sectors.services.member}/findDetail`,
    },
    kyc: {
      validate: `${sectors.services.kyc}/validate`,
    },
    deposits: {
      business: `${sectors.services.deposits}/business`,
    },
  },
  holdings: {
    assets: {
      findList: `${sectors.holdings.assets}/findList`,
    },
  },
};

/**
 * Experience API 엔드포인트 URL
 * @type {string}
 */
export const APIS = {
  auth: {
    verification: {
      additional: {
        activate: `${details.auth.verification.additional}/activate`,
        confirmOverseasDeparture: `${details.auth.verification.additional}/confirmOverseasDeparture`,
        createARSAuthNumber: `${details.auth.verification.additional}/createARSAuthNumber`,
        applyARS: `${details.auth.verification.additional}/applyARS`,
        applySMSIdentify: `${details.auth.verification.additional}/applySMSIdentify`,
        applySimple: `${details.auth.verification.additional}/applySimple`,
        validateSimple: `${details.auth.verification.additional}/validateSimple`,
        getDeviceAuth: `${details.auth.verification.additional}/getDeviceAuth`,
        registDeviceAuth: `${details.auth.verification.additional}/registDeviceAuth`,
        activateIdVerification: `${details.auth.verification.additional}/activateIdVerification`,
      },
      tokens: {
        activate: `${details.auth.verification.tokens}/activate`,
        selectMotpDeviceStatus: `${details.auth.verification.tokens}/selectMotpDeviceStatus`,
        sendMotpPush: `${details.auth.verification.tokens}/sendMotpPush`,
      },
      fintech: {
        verifyFintechCertLoginSign: `${details.auth.verification.fintech}/verifyFintechCertLoginSign`,
        checkFintechCertUser: `${details.auth.verification.fintech}/checkFintechCertUser`,
        verifyFintechCertSign: `${details.auth.verification.fintech}/verifyFintechCertSign`,
        inquiryCiInfo: `${details.auth.verification.fintech}/inquiryCiInfo`,
      },
      fido: {
        requestFidoService: `${details.auth.verification.fido}/requestFidoService`,
      },
      sign: {
        requestSignVerify: `${details.auth.verification.sign}/requestSignVerify`,
      },
    },
    certification: {
      fintech: {
        validateFintechCertCertificate: `${details.auth.certification.fintech}/validateFintechCertCertificate`,
      },
    },
    identity: {
      liveness: {
        getTarget: `${details.auth.identity.liveness}/getTarget`,
      },
      ocr: {
        getNonFaceAuthInfo: `${details.auth.identity.ocr}/getNonFaceAuthInfo`,
      },
    },
    authenticator: {
      management: {
        getMotpPinNum: `${details.auth.authenticator.management}/getMotpPinNum`,
        custInfoLeakerTranBlock: `${details.auth.authenticator.management}/custInfoLeakerTranBlock`,
      },
    },
    user: {
      help: {
        checkLoginOrAuth: `${details.auth.user.help}/checkLoginOrAuth`,
      },
    },
  },
  utilities: {
    functions: {
      terms: {
        inquiryTerms: `${details.utilities.functions.terms}/inquiryTerms`,
        inquiryProductTerms: `${details.utilities.functions.terms}/inquiryProductTerms`,
      },
      edoc: {
        inquiryEdocInfo: `${packages.utilities}/inquiryEdocInfo`,
      },
      account: {
        list: `${details.utilities.functions.account}/list`,
      },
      search: {
        findAddress: `${details.utilities.functions.search}/findAddress`,
        findAddressRefine: `${details.utilities.functions.search}/findAddressRefine`,
        findEmployee: `${details.utilities.functions.search}/findEmployee`,
        findBranch: `${details.utilities.functions.search}/findBranch`,
        findOffice: `${details.utilities.functions.search}/findOffice`,
      },
      clickToCall: {
        validate: `${details.utilities.functions.clickToCall}/validate`,
        send: `${details.utilities.functions.clickToCall}/send`,
      },
      holiday: {
        list: `${details.utilities.functions.holiday}/list`,
      },
      tradeinfo: {
        inquiryCheckOngoingTradeInfo: `${details.utilities.functions.tradeinfo}/inquiryCheckOngoingTradeInfo`,
        inquiryOngoingTradeInfo: `${details.utilities.functions.tradeinfo}/inquiryOngoingTradeInfo`,
        registOngoingTradeInfoScrnRcvry: `${details.utilities.functions.tradeinfo}/registOngoingTradeInfoScrnRcvry`,
        registOngoingTradeInfoLms: `${details.utilities.functions.tradeinfo}/registOngoingTradeInfoLms`,
        registOngoingTradeInfoPtnrProcess: `${details.utilities.functions.tradeinfo}/registOngoingTradeInfoPartnerProcess`,
        cancelOngoingTradeInfo: `${details.utilities.functions.tradeinfo}/cancelOngoingTradeInfo`,
        cancelOnoingProcess: `${details.utilities.functions.tradeinfo}/cancelOnoingProcess`,
        registScrapingData: `${details.utilities.functions.tradeinfo}/registScrapingData`,
        registRecoveryData: `${details.utilities.functions.tradeinfo}/registRecoveryData`,
        inquiryScreenAndScrapingInfo: `${details.utilities.functions.tradeinfo}/inquiryScreenAndScrapingInfo`,
      },
      comfyBank: {
        registerComfyBank: `${details.utilities.functions.comfyBank}/registerComfyBank`,
      },
      emergency: {
        search: `${details.utilities.functions.emergency}/search`,
      },
      authority: {
        checkServiceTime: `${details.utilities.functions.authority}/checkServiceTime`,
      },
    },
    settings: {
      code: {
        list: `${details.utilities.settings.code}/list`,
        listBankCode: `${details.utilities.settings.code}/listBankCode`,
      },
    },
    app: {
      review: {
        getAppReviewInfo: `${details.utilities.app.review}/getAppReviewInfo`,
        registAppReview: `${details.utilities.app.review}/registAppReview`,
      },
    },
    mydata: {
      public: {
        getMyData: `${details.utilities.mydata.public}/getMyData`,
        getProviderRequestsInfo: `${details.utilities.mydata.public}/getProviderRequestsInfo`,
        validateGovmDataCert: `${details.utilities.mydata.public}/validateGovmDataCert`,
      },
    },
  },
  services: {
    member: {
      findDetail: {
        getCustInfo: `${details.services.member.findDetail}/getCustInfo`,
      },
    },
    kyc: {
      validate: {
        getCheckIsAbroad: `${details.services.kyc.validate}/inquiryCheckIsAbroad`,
        getCddOverDueModel: `${details.services.kyc.validate}/inquiryCddOverDueModel`,
        getCddCustInfoModel: `${details.services.kyc.validate}/inquiryCddCustInfoModel`,
        registCddCustInfo: `${details.services.kyc.validate}/registCddCustInfo`,
        checkCddStatus: `${details.services.kyc.validate}/inquiryCheckCddStatus`,
        getPurposeCheckModel: `${details.services.kyc.validate}/inquiryPurposeCheckModel`,
        getCheckCddFatca: `${details.services.kyc.validate}/inquiryCheckCddFatca`,
        registCddFatca: `${details.services.kyc.validate}/registCddFatca`,
        registDistructionCustomer: `${details.services.kyc.validate}/registDistructionCustomer`,
        inquiryExposedPerson: `${details.auth.user.settings}/inquiryExposedPerson`,
        getKCddViewModel: `${details.services.kyc.validate}/inquiryKCddViewModel`,
        prcKCddRegisterStatus: `${details.services.kyc.validate}/prcKCddRegisterStatus`,
        getKCddCompleteViewModel: `${details.services.kyc.validate}/inquiryKCddCompleteViewModel`,
        getEJuso: `${details.services.kyc.validate}/inquiryEJuso`,
        getCusContactCenterViewModel: `${details.services.kyc.validate}/inquiryCusContactCenterViewModel`,
        getCddSoleProprietorBlockModel: `${details.services.kyc.validate}/inquiryCddSoleProprietorBlockModel`,
        getCddAdditionalDocViewModel: `${details.services.kyc.validate}/inquiryCddAdditionalDocViewModel`,
        getPrcKCddEdocMerge: `${details.services.kyc.validate}/inquiryPrcKCddEdocMerge`,
        prcKCddEdocSaveServer: `${details.services.kyc.validate}/prcKCddEdocSaveServer`,
        prcKCddEdocMergeRcvry: `${details.services.kyc.validate}/prcKCddEdocMergeRcvry`,
        getCddMotpPurposeCheckViewModel: `${details.services.kyc.validate}/inquiryCddMotpPurposeCheckViewModel`,
        getKCddEdocCreateModeData: `${details.services.kyc.validate}/inquiryKCddEdocCreateModeData`,
      },
    },
    deposits: {
      business: {
        validateFundAdditionalInvestmentSuitabilityCheck: `${details.services.deposits.business}/validateFundAdditionalInvestmentSuitabilityCheck`,
        validateProductAvailabilityCheck: `${details.services.deposits.business}/validateProductAvailabilityCheck`,
      },
    },
  },
  holdings: {
    assets: {
      findList: {
        listMainAssets: `${details.holdings.assets.findList}/listMainAssets`,
      },
    },
  },
};
